import { useTranslations } from "next-intl";
import isEmail from "validator/es/lib/isEmail";
import isInt from "validator/es/lib/isInt";
import matches from "validator/lib/matches";
import isLength from "validator/lib/isLength";

const useFormValidators = () => {
  const t = useTranslations();

  const required = { value: true, message: t("field_error_required") };

  const validateMaxLength = (maxLength: number) => (value) => {
    if (isLength(value || "", { max: maxLength })) return true;
    return t("error_max_length", { maxLength });
  };

  const validateNotEmpty = (value) => {
    let isValid = true;

    if (typeof value === "string" && value.trim() === "") {
      isValid = false;
    }
    if (typeof value === "number" && (isNaN(value) || value <= 0)) {
      isValid = false;
    }
    if (!isValid) return t("field_error_required");
    return true;
  };
  const validateEmail = (value) => {
    if (value && isEmail(value)) return true;
    return t("email_invalid");
  };

  const validatePostalCode = (value) => {
    if (
      isInt(value || "", { min: 1000, max: 9699, allow_leading_zeroes: false })
    ) {
      return true;
    }
    return t("error_postal_code_invalid");
  };

  const validatePhoneNumber = (value) => {
    if (
      value &&
      value?.trim() &&
      matches(value || "", /^[0+]{1}[0-9() ]{9,25}$/g)
    )
      return true;
    return t("error_phone_number_invalid");
  };
  const validateContactNumber = (value) => {
    if (matches(value || "", /^[k]\d{6}$/gi)) return true;
    return t("error_contact_number_invalid");
  };

  const validateName = (value) => {
    if (
      value &&
      value?.trim() &&
      matches(value || "", /^[^0-9_$!?*%&/+:;.,<>¨^"'@#]*$/g)
    )
      return true;
    return t("error_name_invalid");
  };
  const validateDateBefore = (dateToCompare) => (value) => {
    if (!value || new Date(value).getTime() > new Date(dateToCompare).getTime())
      return t("error_date_before", {
        dateToCompare: new Date(dateToCompare || null).toLocaleDateString(),
      });
    return true;
  };

  const validateDateAfter = (dateToCompare) => (value) => {
    if (!value || new Date(value).getTime() < new Date(dateToCompare).getTime())
      return t("error_date_after", {
        dateToCompare: new Date(dateToCompare || null).toLocaleDateString(),
      });
    return true;
  };

  const validateWeekday = (value) => {
    const dayOfWeek = new Date(value).getDay();
    if (dayOfWeek === 6 || dayOfWeek === 0) {
      return t("error_date_weekend");
    }
    return true;
  };

  return {
    required,
    validateEmail,
    validatePostalCode,
    validatePhoneNumber,
    validateContactNumber,
    validateName,
    validateNotEmpty,
    validateMaxLength,
    validateDateAfter,
    validateDateBefore,
    validateWeekday,
  };
};

export default useFormValidators;
